import { i18n as sparkTranslations } from '@digistorm/spark'

export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'en-AU',
    silentTranslationWarn: true,
    messages: sparkTranslations,
}))